import React, { Component } from 'react';
import './SavingsPlan.css';
import ContextConstructor from "../../components/Context/Context";
import sendLogError from "../../sendLogError";

import piggyBankImg from "../../images/piggy-bank.svg";
import checkCircleImg from "../../images/check-circle.svg";
import errorImg from "../../pages/ResponsePages/imgs/error.png";
import poupancaImg from "../../images/poupanca.svg"
import termsImg from "../../images/terms-icon.svg";
import loadingImg from "../../images/loading.svg";

const CONSTANTS = {
    TOAST_DURATION: 4000,
    MIN_AMOUNT: 20,
    MAX_AMOUNT: 500000
};
const documentosPoupanca = {
    regulamento: 'https://www.montepio.org/wp-content/uploads/2023/07/RB_4nov2013_T2_C1_S1_MPC_abr23.pdf',
    fichaTecnica: 'https://www.montepio.org/wp-content/uploads/2025/01/FT_MIG1_MPC_06jan2025_V1.pdf',
    beneficios: 'https://www.montepio.org/wp-content/uploads/2023/12/RB_Montepio_Geral_Associacao_Mutualista_2023-24.pdf',
    estatutos: 'https://www.montepio.org/wp-content/uploads/2023/12/Estatutos_Montepio_Geral_Associacao_Mutualista_2023-24-1.pdf',
};
const documentosPlanoReforma = {
    regulamento: 'https://www.montepio.org/wp-content/uploads/2023/07/RB_4nov2013_T2_C1_S2_MPpR_abr23.pdf',
    fichaTecnica: 'https://www.montepio.org/wp-content/uploads/2025/01/FT_MIG1_MPpR_06jan2025_v1.pdf',
    beneficios: 'https://www.montepio.org/wp-content/uploads/2023/12/RB_Montepio_Geral_Associacao_Mutualista_2023-24.pdf',
    estatutos: 'https://www.montepio.org/wp-content/uploads/2023/12/Estatutos_Montepio_Geral_Associacao_Mutualista_2023-24-1.pdf',
};

const documentosPorProduto = {
    '7365': documentosPoupanca,
    '7375': documentosPlanoReforma,
};

class SavingsPlan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,
            metodo: 'debito',
            montante: '',
            aceitouTermos1: false,
            aceitouTermos2: false,
            erroMontante: true,
            reforcoEnviado: false,
            reforcoErro: false,
            reforcoLoading: false
        };
    }
    async componentDidMount() {
        const { associateInfo, params, modalidade } = this.props;
        const userInfo = this.context.selectedUser;
        params.associateID = userInfo.associateID;
        this.populateReinforcement();
    }

    showErrorToast = (mensagem) => {
        const toast = document.createElement("div");
        toast.className = "toast-error";
        toast.innerText = mensagem;

        document.body.appendChild(toast);

        setTimeout(() => {
            toast.remove();
        }, CONSTANTS.TOAST_DURATION);
    };

    async populateReinforcement() {
        try {
            const { modalidade, params } = this.props;
            const { associateID } = this.context.selectedUser;
            const { idToken } = this.context;

            const product = modalidade?.productID || "";

            const productNumber = product?.substring(0, 2) || "";
            const byproductNumber = product?.substring(2) || "";

            const subscriptionNumber = parseInt(params?.subscriptionNumber, 10) || 0;

            const payload = {
                associateReference: associateID,
                productNumber,
                byproductNumber,
                subscriptionNumber,
            };

            const response = await fetch("/Savings/PopulateReinforcement", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                console.error("PopulateReinforcement failed:", response.status);

                this.handleReinforcementError();
                return;
            }

            const data = await response.json();

            this.setState({
                associateInfo: data
            });

        } catch (error) {
            console.error("Error in populateReinforcement:", error);

            sendLogError(error.message, "populateReinforcement");

            this.handleReinforcementError();
        }
    }

    handleReinforcementError() {
        this.showErrorToast("Erro ao carregar dados. Tente novamente.");

        setTimeout(() => this.props.onClose(), CONSTANTS.TOAST_DURATION);
    }

    handleNext = () => {
        this.setState(prev => ({
            currentStep: Math.min(prev.currentStep + 1, 3)
        }));
    }

    handleBack = () => {
        this.setState(prev => ({
            currentStep: Math.max(prev.currentStep - 1, 1)
        }));
    }

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        let erroMontante = this.state.erroMontante;

        if (name === 'montante') {
            const numero = parseFloat(value);
            erroMontante = isNaN(numero) || numero < CONSTANTS.MIN_AMOUNT || numero > CONSTANTS.MAX_AMOUNT;
        }

        this.setState({
            [name]: newValue,
            ...(name === 'montante' && { erroMontante })
        });
    }

    handleSubmit = async () => {
        const { metodo, montante, associateInfo } = this.state;
        const { mymEmail } = this.context.selectedUser;
        const idToken = this.context.idToken;
        if (this.state.reforcoLoading) return;

        try {
            if (!associateInfo) {
                alert("Dados do associado não carregados.");
                return;
            }

            this.setState({ reforcoLoading: true });

            const payload = {
                ...associateInfo,
                AssociateEmail: mymEmail,
                paymentType: 'DEBITO_DIRETO',
                operationAmount: parseFloat(montante),
            };

            const response = await fetch("/Savings/CreateReinforcement", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                this.setState({ reforcoErro: true, reforcoLoading: false });
                return;
            }

            const result = await response.json();
            this.setState({ reforcoEnviado: true, reforcoLoading: false });

        } catch (error) {
            this.setState({ reforcoErro: true, reforcoLoading: false });
        }
    };


    renderPasso = () => {
        const {
            currentStep,
            metodo,
            montante,
            aceitouTermos1,
            aceitouTermos2,
            reforcoEnviado,
            reforcoErro
        } = this.state;

        const { params, modalidade } = this.props;
        const nomeModalidade = modalidade?.productName || "Modalidade";
        if (currentStep === 1) {

            const numeroInscricao = params?.subscriptionNumber || "N/A";

            return (
                <div className="passo1-container">
                    <div className="row linha">
                        <div className="coluna-esquerda">
                            <div className="titulo-laranja">Montante</div>
                            <img src={piggyBankImg} alt="icone-porquinho" className="icone-porquinho" />
                        </div>

                        <div className="coluna-direita">
                            <div className="passo1-subtitulo">
                                Reforce a modalidade <strong>{nomeModalidade.toLowerCase()}</strong> – Inscrição N.º <strong>{numeroInscricao}</strong> de forma simples e rápida.
                            </div>
                            <hr className="separador-subtitulo" />
                            <div className="form-group">
                                <label className="label pequeno">Montante</label>
                                <div className="montante-wrapper">
                                    <input
                                        type="number"
                                        name="montante"
                                        value={montante}
                                        onChange={this.handleChange}
                                        className="dropdown-subscrpiton pequeno"
                                        placeholder="Insira entre 20€ e 500 000€"
                                    />
                                    <span className="simbolo-euro">€</span>
                                </div>
                                {montante !== '' && this.state.erroMontante && (
                                    <div className="erro-texto pequeno">
                                        Insira um valor entre 20€ e 500 000€.
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label className="label pequeno">Selecione o método de pagamento</label>
                                <input type="text" className="dropdown-subscrpiton pequeno" value="Débito Direto" disabled />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (currentStep === 2) {
            const docs = documentosPorProduto[this.props.modalidade.productID] || {};
            return (
                <div className="passo2-container">
                    <div className="row passo2-linha">
                        <div className="passo2-coluna-esquerda">
                            <div className="passo2-titulo">Termos e Condições</div>
                            <img
                                src={termsImg}
                                alt="terms"
                                className="passo2-icone"
                            />
                        </div>

                        <div className="passo2-coluna-direita">
                            <div className="passo2-checkbox-plan">
                                <label className="passo2-checkbox-label-plan">
                                    <input
                                        type="checkbox"
                                        name="aceitouTermos1"
                                        checked={aceitouTermos1}
                                        onChange={this.handleChange}
                                    />
                                    <span className="passo2-texto-plan">
                                        Declaro ter compreendido e aceite a{" "}
                                        {docs.fichaTecnica ? (
                                            <a
                                                href={docs.fichaTecnica}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="passo2-laranja"
                                            >
                                                Ficha Técnica da Modalidade
                                            </a>
                                        ) : (
                                            <span className="passo2-laranja">
                                                Ficha Técnica da Modalidade
                                            </span>
                                        )}
                                        , o{" "}
                                        {docs.regulamento ? (
                                            <a
                                                href={docs.regulamento}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="passo2-laranja"
                                            >
                                                Regulamento da Modalidade
                                            </a>
                                        ) : (
                                            <span className="passo2-laranja">
                                                Regulamento da Modalidade
                                            </span>
                                        )}{" "}
                                        e demais condições constantes do{" "}
                                        {docs.beneficios ? (
                                            <a
                                                href={docs.beneficios}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="passo2-laranja"
                                            >
                                                Regulamento de Benefícios do Montepio Geral - Associação Mutualista
                                            </a>
                                        ) : (
                                            <span className="passo2-laranja">
                                                Regulamento de Benefícios do Montepio Geral - Associação Mutualista
                                            </span>
                                        )}
                                        , assim como os seus{" "}
                                        {docs.estatutos ? (
                                            <a
                                                href={docs.estatutos}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="passo2-laranja"
                                            >
                                                Estatutos
                                            </a>
                                        ) : (
                                            <span className="passo2-laranja">Estatutos</span>
                                        )}
                                        .
                                    </span>
                                </label>
                            </div>

                            <div className="passo2-checkbox-plan">
                                <label className="passo2-checkbox-label-plan">
                                    <input
                                        type="checkbox"
                                        name="aceitouTermos2"
                                        checked={aceitouTermos2}
                                        onChange={this.handleChange}
                                    />
                                    <span className="passo2-texto-plan">
                                        Tomei conhecimento que para efeito de reembolsos da presente subscrição
                                        será utilizada a conta de depósitos à ordem associada aos encargos
                                        associativos.
                                    </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }


        if (currentStep === 3) {
            if (reforcoEnviado) {
                return (
                    <div className="sucesso-finalizado">
                        <div className="icone-check">
                            <img src={checkCircleImg} alt="Sucesso" width="64" height="64" />
                        </div>
                        <h2 > O seu reforço foi efetuado com sucesso</h2>
                    </div>
                );
            }

            if (reforcoErro) {
                return (
                    <div className="erro-finalizado">
                        <div className="icone-check">
                            <img src={errorImg} alt="Erro" width="64" height="64" />
                        </div>
                        <h2 >Ocorreu um erro ao efetuar o reforço</h2>
                        <p>Não foi possível processar o seu pedido. Tente novamente mais tarde.</p>
                    </div>
                );
            }

            return (
                <div className="confirmacao-detalhada">
                    <div className="icone-lateral">
                        <span style={{ color: '#f60', fontWeight: 'bold', fontSize: 18 }}>Confirmar dados</span>
                        <img src={poupancaImg} alt="Confirmação" style={{ width: 80 }} />
                    </div>

                    <div className="caixa-confirmacao">
                        <div style={{ fontSize: 18, fontWeight: "bold", marginBottom: "16px" }}>
                            Reforçar Poupança - Entrega complementar
                        </div>

                        <div className="linha-montantes">
                            <div>
                                <div className="subtitulo">Montante</div>
                                <div className="valor">
                                    {new Intl.NumberFormat("pt-PT", {
                                        style: "currency",
                                        currency: "EUR"
                                    }).format(montante || 0)}
                                </div>
                            </div>

                            <div style={{ textAlign: "right" }}>
                                <div className="subtitulo" style={{ color: "#333" }}>Método de pagamento</div>
                                <div className="valor" style={{ color: "#333" }}>
                                    Débito Direto
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }

    render() {
        const {
            currentStep,
            erroMontante,
            aceitouTermos1,
            aceitouTermos2,
            reforcoEnviado,
            reforcoErro
        } = this.state;

        return (
            <div className="form-container">
                <div className="form-wrapper">
                    <h1 className="titulo">{this.props.productName || "Poupança"}</h1>

                    <div className="etapas">
                        {[1, 2, 3].map(n => {
                            const statusClass = currentStep === n ? 'ativa' : currentStep > n ? 'completa' : '';
                            const label = n === 1 ? 'Montante' : n === 2 ? 'Termos e Condições' : 'Confirmar dados';
                            return (
                                <div key={n} className={`etapa ${statusClass}`}>
                                    <div className="bolinha">{n}</div>
                                    <span>{label}</span>
                                </div>
                            );
                        })}
                        <div className="progresso-container">
                            <div
                                className="progresso-barra"
                                style={{
                                    width: reforcoEnviado ? '100%' : `${(currentStep - 1) / 2 * 100}%`
                                }}
                            />
                        </div>
                    </div>

                    {this.renderPasso()}

                    <div className="botoes">
                        {currentStep === 1 && (
                            <button onClick={this.props.onClose} className="botao voltar">Voltar</button>
                        )}
                        {currentStep > 1 && !reforcoEnviado && !reforcoErro && (
                            <button onClick={this.handleBack} className="botao voltar">Voltar</button>
                        )}
                        {currentStep < 3 && (
                            ((currentStep !== 1 && currentStep !== 2) ||
                                (currentStep === 1 && !erroMontante) ||
                                (currentStep === 2 && aceitouTermos1 && aceitouTermos2)
                            ) && (
                                <button onClick={this.handleNext} className="botao laranja">Continuar</button>
                            )
                        )}
                        {currentStep === 3 && !reforcoEnviado && !reforcoErro && (
                            <button
                                onClick={this.handleSubmit}
                                className="botao verde"
                                disabled={this.state.reforcoLoading}
                            >
                                {this.state.reforcoLoading ? (
                                    <div className="botao-spinner-wrapper">
                                        <img
                                            src={loadingImg}
                                            alt="Carregando"
                                            className="spinner-icon"
                                        />
                                        <span>A processar...</span>
                                    </div>
                                ) : (
                                    "Confirmar"
                                )}
                            </button>
                        )}
                        {currentStep === 3 && (reforcoEnviado || reforcoErro) && (
                            <button onClick={this.props.onClose} className="botao verde">Fechar</button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

SavingsPlan.contextType = ContextConstructor;
export default SavingsPlan;
